import { Panel, Progress } from 'rsuite';
import styled from 'styled-components';

export const StyledPanel = styled(Panel)`
  width: 300px;
  > .rs-panel-body {
    padding: 10px;
  }
`;

export const StyledProgressLine = styled(Progress.Line)`
  width: 300px;
  padding-left: 0;
  padding-bottom: 0;
  > .rs-progress-info > .rs-progress-icon-success,
  > .rs-progress-info > .rs-progress-info-status {
    font-size: 14px;
  }
`;

export const UploadDisabler = styled.div`
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  position: absolute;
  background: #ddd;
  border-radius: 5px;
`;
